'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = template;
function template(value) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof value === 'string') {
    return value.replace(/{(\w*)}/g, function (match, key) {
      return data.hasOwnProperty(key) ? data[key] : '';
    });
  }

  return value;
}
//# sourceMappingURL=template.js.map